import { dataBarChartSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBarChartSquare = /*#__PURE__*/createIcon(dataBarChartSquare)
export default IconBarChartSquare
